// @ts-ignore
import "babel-polyfill/browser";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { buildNumber } from "./buildNumber";
import { IdDomElement } from "./constants/IdDomElement";
import { IdEnvironment } from "./constants/IdEnvironment";
import { IdPersistence } from "./constants/IdPersistence";
import { eventsStore } from "./events/eventsStore";
import { App } from "./features/app/App";
import { appCanvas } from "./features/app/appCanvas";
import { bugsnagClient } from "./features/bugsnag/bugsnagClient";
import { ErrorBoundary } from "./features/generic/ErrorBoundary";
import { landingPageMessageHandler } from "./features/landing-page/landingPageMessageHandler";
import { actionModalOpen } from "./features/modals/actionModal";
import { IdModal } from "./features/modals/IdModal";
import { IdNetwork } from "./features/network/IdNetwork";
import "./less/index.less";
import { assetConfig } from "./setup/assetConfig";
import { configureStore } from "./setup/configureStore";
import { globalConfig } from "./setup/globalConfig";
import { gridConfig } from "./setup/gridConfig";
import { unregister as unregisterServiceWorker } from "./setup/registerServiceWorker";
import { rootEpic } from "./setup/rootEpic";
import { rootReducer } from "./setup/rootReducer";
import { utilLoader } from "./utils/loader/utilLoader";
import { decodeIdInWrapper } from "./utils/network/decoder/decodeIdInWrapper";
import { decodeLengthPrefix } from "./utils/network/decoder/decodeLengthPrefix";
import { encodeIdInWrapper } from "./utils/network/encoder/encodeIdInWrapper";
import { encodeLengthPrefix } from "./utils/network/encoder/encodeLengthPrefix";
import { proto } from "./utils/network/generated/proto";
import { protoGeneric } from "./utils/network/generated/protoGeneric";
import { CommandCode, StatusCode } from "./utils/network/generated/protoTypes";
import { UtilNetwork } from "./utils/network/UtilNetwork";
import { utilEnvironment } from "./utils/utilEnvironment";
import { utilPersistence } from "./utils/utilPersistence";
import { utilVersion } from "./utils/utilVersion";
unregisterServiceWorker();
utilVersion.setBuildNumber(buildNumber);
if (utilVersion.getCurrentVersion() !== utilVersion.getPreviousVersion() && window.caches) {
    window.caches.keys().then(function (names) {
        names.forEach(function (name) {
            window.caches.delete(name);
        });
    });
}
var bugsnagConfig = {
    apiKey: "86de7f7f2eefaf0db45bfe5dc2370318",
    appVersion: utilVersion.getCurrentVersion(),
    collectUserIp: false,
    metaData: { notifyContext: "autoNotify" },
    notifyReleaseStages: [IdEnvironment.Production, IdEnvironment.Staging],
    releaseStage: utilEnvironment.current,
};
bugsnagClient.setup(bugsnagConfig);
var _a = new UtilNetwork(IdNetwork.Core, proto, CommandCode, StatusCode, encodeLengthPrefix, decodeLengthPrefix), connectionStatus$ = _a.connectionStatus$, netSend = _a.netSend, netReceive$ = _a.netReceive$, netConnect = _a.connect, netDisableConnections = _a.disableConnections, netEnableConnections = _a.enableConnections;
var _b = new UtilNetwork(IdNetwork.Chat, proto, CommandCode, StatusCode, encodeIdInWrapper, decodeIdInWrapper, protoGeneric), chatConnectionStatus$ = _b.connectionStatus$, chatNetSend = _b.netSend, chatNetReceive$ = _b.netReceive$, chatNetConnect = _b.connect;
var _c = new UtilNetwork(IdNetwork.Notification, proto, CommandCode, StatusCode, encodeIdInWrapper, decodeIdInWrapper, protoGeneric), notificationConnectionStatus$ = _c.connectionStatus$, notificationNetSend = _c.netSend, notificationNetReceive$ = _c.netReceive$, notificationNetConnect = _c.connect;
var store = configureStore({
    bugsnag: bugsnagClient.bugsnag,
    connectionStatus$: connectionStatus$,
    inStoreDependencies: {
        viewportChanged$: appCanvas.viewportChange$,
    },
    netConnect: netConnect,
    netDisableConnections: netDisableConnections,
    netEnableConnections: netEnableConnections,
    netReceive$: netReceive$,
    netSend: netSend,
    utilLoader: utilLoader,
    chatConnectionStatus$: chatConnectionStatus$,
    chatNetConnect: chatNetConnect,
    chatNetReceive$: chatNetReceive$,
    chatNetSend: chatNetSend,
    notificationConnectionStatus$: notificationConnectionStatus$,
    notificationNetConnect: notificationNetConnect,
    notificationNetReceive$: notificationNetReceive$,
    notificationNetSend: notificationNetSend,
}, rootReducer, rootEpic);
globalConfig.setup(assetConfig);
eventsStore.setup(store);
appCanvas.setup(gridConfig, assetConfig);
appCanvas.start();
landingPageMessageHandler.setup();
landingPageMessageHandler.getReferrer();
var credentials = utilPersistence.getValue(IdPersistence.Credentials, {});
if (utilEnvironment.isDevelopment() && Object.keys(credentials).length === 0) {
    store.dispatch(actionModalOpen(IdModal.EnvSelect));
}
else {
    setTimeout(landingPageMessageHandler.doAutoLogin, 100);
}
/**
 * Wraps React render function in another function
 * to enable hot reloading.
 */
var render = function () {
    return ReactDOM.render(React.createElement(ErrorBoundary, { client: bugsnagClient.bugsnag, name: "index.tsx" },
        React.createElement(App, { store: store })), document.getElementById(IdDomElement.DomRoot));
};
render();
// Webpack HMR
if (module.hot) {
    module.hot.accept("./features/app/App", function () {
        render();
    });
    module.hot.accept("./features/scenes/scenes", function () {
        render();
    });
    module.hot.accept("./features/player-base/hud/BF2HudPlayerBaseDOM", function () {
        render();
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 979
// module chunks = 3